import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthComponent } from '../../core/auth/components/auth.component';
import { AuthGuard } from '../../core/auth/guards/auth.guard';
import { ChangePasswordGuard } from '../../core/auth/guards/change-password.gaurd';
import { RedirectGuard } from '../../core/auth/guards/redirect.guard';
import { LoginComponent } from '../../core/login/components/login.component';
import { ResetPasswordComponent } from '../reset-password/reset-password.component';
import { AnalyticsContentComponent } from './components/analytics-content.component';
import { AnalyticsComponent } from './components/analytics.component';
import { CanActivateAnalyticsGuard } from './guards/canactivate-analytics.guard';

export const routes: Routes = [
	{ path: '', component: AuthComponent, canActivate: [AuthGuard] },
	{ path: 'login', component: LoginComponent, canActivate: [AuthGuard] },
	{ path: 'reset_password/:userid/:passkey', component: ResetPasswordComponent, canActivate: [ChangePasswordGuard] },
	{ path: 'redirect/:aTkn', component: LoginComponent, canActivate: [RedirectGuard] },
	{ path: 'forgot_password', component: LoginComponent, canActivate: [AuthGuard] },
	{
		canActivate: [AuthGuard, CanActivateAnalyticsGuard],
		children: [
			{ path: 'overview', component: AnalyticsContentComponent },
			{ path: 'display', component: AnalyticsContentComponent },
			{ path: 'geofence', component: AnalyticsContentComponent },
			{ path: 'preroll', component: AnalyticsContentComponent },
			{ path: 'video', component: AnalyticsContentComponent },
			{ path: 'geovideo', component: AnalyticsContentComponent },
			{ path: 'videogeofencing', component: AnalyticsContentComponent },
			{ path: 'sem', component: AnalyticsContentComponent },
			{ path: 'ctv', component: AnalyticsContentComponent },
			{ path: 'television', component: AnalyticsContentComponent },
			{ path: 'enterprise_reporting', component: AnalyticsContentComponent },
			{ path: 'social', component: AnalyticsContentComponent },
			{ path: 'television', component: AnalyticsContentComponent },
			{ path: 'radio', component: AnalyticsContentComponent },
			{ path: 'audio', component: AnalyticsContentComponent },
			{ path: 'tve', component: AnalyticsContentComponent },
			{ path: 'ott', component: AnalyticsContentComponent },
			{ path: 'email', component: AnalyticsContentComponent },
			{ path: 'triton_radio', component: AnalyticsContentComponent },
			{ path: 'responsive_display', component: AnalyticsContentComponent },
			{ path: 'gam', component: AnalyticsContentComponent },
			{ path: 'looker-sem', component: AnalyticsContentComponent },
			{ path: 'looker-ctv', component: AnalyticsContentComponent },
			{ path: 'dooh', component: AnalyticsContentComponent }
		],
		component: AnalyticsComponent,
		path: 'dashboard'
	}
];

export const AuthRoutesModule: ModuleWithProviders<any> = RouterModule.forChild(routes);
